import { render, staticRenderFns } from "./sideNav.vue?vue&type=template&id=39f8601c&"
import script from "./sideNav.vue?vue&type=script&lang=js&"
export * from "./sideNav.vue?vue&type=script&lang=js&"
import style0 from "./sideNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports